import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorageService } from '@ndk/ng-storage';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { AccountTypes } from '@core/authentication/shared/account-types.enum';
import { RoleTypes } from '@core/authentication/shared/role-types.enum';
import { LocalStorageKeys } from '@core/storage/local-storage.enum';

@Injectable()
export class NotAllowManagerWhenAccountIsPrinterTypeGuardService implements CanActivate {

    constructor(
        private authTokenService: AuthTokenService,
        private localStorageService: LocalStorageService,
        private router: Router,
    ) { }

    public canActivate(): boolean {

        // tslint:disable-next-line:no-bitwise
        if (this.authTokenService.role & RoleTypes.User) {
            if (this.authTokenService.isUserManager) {
                if (this.localStorageService.getValue(LocalStorageKeys.AccountType) !== AccountTypes.PrinterDevices) {
                    return true;
                }
            }

            this.router.navigate(['page-forbidden']);

            return false;
        }

        return true;
    }

}
